import { render } from "./list-category.vue?vue&type=template&id=34d15b78&scoped=true"
import script from "./list-category.vue?vue&type=script&lang=js"
export * from "./list-category.vue?vue&type=script&lang=js"

import "./list-category.vue?vue&type=style&index=0&id=34d15b78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d15b78"]])

export default __exports__